module.exports = __webpack_public_path__ + "img/titles8.a3f40f0a.png";